import type { KsefEnvironment } from '@ip/shared-types';

/** Badge colors for the KSeF issuance environments — shared by the section
 *  header (FiscalLayout), the API-token table and the invoice list. */
export const ENV_BADGE_CLASS: Record<KsefEnvironment, string> = {
  demo: 'border-transparent bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
  test: 'border-transparent bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
  production: 'border-transparent bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300',
};
